import { Card, CardContent, Grid, Typography } from '@mui/material'

export default function SettingsDetailsCard() {
  return (
    <Card>
      <CardContent>
        <Grid container alignItems='cener'>
          <Grid item xs={12}>
            <Typography fontWeight='bold' variant='h5'>
              Settings
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
